import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    loading: false,
    error: null,
    uploadedFile: null,
};
const fileSlice = createSlice({
    name: 'file',
    initialState,
    reducers: {
        fileUploadStart(state) {
            state.loading = true;
            state.error = null;
        },
        fileUploadSuccess(state, action) {
            state.loading = false;
            state.uploadedFile = action.payload;
        },
        fileUploadFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
    },
});
export const { fileUploadStart, fileUploadSuccess, fileUploadFailure } = fileSlice.actions;
export default fileSlice.reducer;
